'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AsyncValidation;
function AsyncValidation($q) {

  function AsyncValidation() {
    this.validators = [];
    this.errors = {};

    this.checking = false;
    this._checkingPromise = null;
  }
  AsyncValidation.prototype.abort = function () {
    if (this.checking) {
      var abortRes;
      var promise = this._checkingPromise;

      if (angular.isFunction(promise.abort)) {
        abortRes = promise.abort();
      }
      this.checking = false;
      return abortRes;
    }
  };
  AsyncValidation.prototype.check = function () {
    this.reset();
    this.checking = true;

    var self = this;
    var aborted = false;

    self._checkingPromise = $q.when();
    this.validators.forEach(function (validator) {
      self._checkingPromise = self._checkingPromise.then(function (result) {
        console.log('[abort check]');
        if (aborted) {
          var d = $q.defer();
          d.reject('aborted');
          return d.promise;
        }
        return $q.when(result);
      });

      self._checkingPromise = self._checkingPromise.then(self._createValidation(validator));
    });

    self._checkingPromise = self._checkingPromise.then(function () {
      // tutte le promise sono state risolte
      self.checking = false;
      console.log('_checkingPromise errors keys:', _.keys(self.errors));
      return !_.keys(self.errors).length; // se nessuna chiave di errore è stata settata, tutto è ok!
    }, function (reason) {
      // qualcosa è andato storto
      self.checking = false;
      if (reason === 'aborted') {
        self.reset();
      }
      return false;
    });

    self._checkingPromise.abort = function () {
      aborted = true;
    };

    return this._checkingPromise;
  };
  AsyncValidation.prototype._createValidation = function (validator) {
    var self = this;
    var validatorName = validator.name;

    return function () {
      return validator.obj.validate.apply(self, arguments).then(function (satisfied) {
        console.log('validator.validate() name="' + validatorName + '" satisfied:', satisfied);
        if (satisfied === true) {
          delete self.errors[validatorName];
          console.log('validator.validate() name="' + validatorName + '" TRUE');
          return true;
        } else {
          self.errors[validatorName] = {
            result: satisfied
          };
          return false;
        }
      }, function (err) {
        self.errors[validatorName] = {
          error: err
        };
        return err;
      });
    };
  };
  AsyncValidation.prototype.reset = function () {
    this.abort();
    this.errors = {};
    this.checking = false;
  };
  AsyncValidation.prototype.addValidator = function (name, validator) {
    this.validators.push({
      name: name,
      obj: validator
    });
  };

  return AsyncValidation;
}
;


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.ui/AsyncValidation.js
// module id = 138
// module chunks = 2